// Import states.
import {
	NewBusinessApplicationState,
	getInitialState as getInitialNewBusinessApplicationState,
} from './NewBusinessApplicationState';
import {
	PublicPolicyViewState,
	getInitialState as getInitialPublicPolicyViewState,
} from './PublicPolicyViewState';
// Import api models.
import {
    EndorsementEligibilityStatus,
	PolicyNoteEmail,
	PolicyNoteRecord,
	ProducerInfo,
} from '@app/models/api';

interface PolicyState {
	newBusinessApplication: NewBusinessApplicationState;
	publicPolicyView: PublicPolicyViewState;
	arePolicyNotesLoaded: boolean;
	arePolicyNoteEmailsLoaded: boolean;
	arePolicyTermYearsLoaded: boolean;
	canPolicyBeCopied?: boolean;
	isProducerLoaded: boolean;
	policyId?: number;
	policyNoteEmails: PolicyNoteEmail[];
	policyNotes: PolicyNoteRecord[];
	policyProducer?: ProducerInfo;
	policyTermYears: number[];
	selectedPolicyNoteId?: number;
	endorsementEligibilityStatus?: EndorsementEligibilityStatus;
};


const getInitialState = (): PolicyState => {
	return {
		newBusinessApplication: getInitialNewBusinessApplicationState(),
		publicPolicyView: getInitialPublicPolicyViewState(),
		arePolicyNotesLoaded: false,
		arePolicyNoteEmailsLoaded: false,
		arePolicyTermYearsLoaded: false,
		canPolicyBeCopied: undefined,
		isProducerLoaded: false,
		policyId: undefined,
		policyNoteEmails: [],
		policyNotes: [],
		policyProducer: undefined,
		policyTermYears: [],
		selectedPolicyNoteId: undefined,
		endorsementEligibilityStatus: undefined,
	};
};

export { getInitialState, PolicyState };